<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
            color="secondary"
            outlined
            class="mr-1 reportBackBtn"
            to="/admin/reports/playlist"
          >
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Playlist
            Reports
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="user-report-button-wrapper" v-if="serverItemsLength > 0">
          <v-btn
            class="mr-1 add-course-button"
            color="primary"
            @click.prevent="exportCsv('excel')"
            outlined
          >
          Email link to download Excel report
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template v-slot:item.test_score="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    {{ item.test_score }}%
                  </span>
                  <span v-else>T.B.C</span>
                </span>
              </template>
              <template v-slot:item.progress="{ item }">
                {{ item.progress }}%
              </template>
              <template v-slot:item.has_test="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    <span v-if="item.test_passed">
                      <v-icon color="green">fa-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="red">fa-times</v-icon>
                    </span>
                  </span>
                  <span v-else> T.B.C </span>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import channelAPI from '@/api/channel.js';
import { EventBus } from '@/event-bus.js';
export default {
  name: 'PlaylistCourseReport',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'title', sortable: false },
        { text: 'User First Name', value: 'user_first_name', sortable: false },
        { text: 'User Last Name', value: 'user_last_name', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Status', value: 'state_text', sortable: false },
        {
          text: 'Date Enrolled',
          value: 'enrolled_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Started',
          value: 'start_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Completed',
          value: 'complete_date_formatted',
          sortable: false,
        },
        { text: 'Progress %', value: 'progress', sortable: false },
        { text: 'Deadline', value: 'deadline_formatted', sortable: false },
        { text: 'Test Score', value: 'test_score', sortable: false },
        { text: 'Passed Test', value: 'has_test', sortable: false },
      ],
      id: this.$route.params.id,
      courses: [],
      loading: false,
      pagination: {},
      options: {},
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      confirmArchive: 'Are you sure you wish to archive course for this user?',  
      successArchiveMessage: 'Course Archived Successfully.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourses();
      });
    },
    getCourses() {
      this.loading = true;
      channelAPI.getDetailedReport(this.id, this.params).then((resp) => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    exportCsv(type) {
      this.loading = true;
      channelAPI
        .exportDetailedReportCSV(this.id,type)
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
  },
};
</script>

<style scoped>
.user-report-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}
.reportBackBtn::before{
  opacity: 0.18;
}

@media (max-width: 960px) {
  .user-report-button-wrapper {
    justify-content: start;
  }
}
</style>
